<ion-header>
  <ion-toolbar color="primary">
    <ion-title>All Properties</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="HomeList">
  @if (loading) {
    <app-loading class="HomeList__Spinner"></app-loading>
  } @else {
    <smartflip-financial-aggregates
      class="HomeList__Aggregates"
    ></smartflip-financial-aggregates>
    <!-- Subscription Banner -->
    <smartflip-home-list-subscription-banner [isPremiumUser]="isPremiumUser">
    </smartflip-home-list-subscription-banner>

    <!-- Action Buttons -->
    @if (buttonStates$ | async; as buttonStates) {
      <span class="HomeList__ButtonWrapper">
        @for (button of buttonList; track button; let i = $index) {
          <div class="HomeList__ButtonColumn">
            <ion-button
              fill="solid"
              color="primary"
              [id]="button.id || button.action"
              data-test-id="button.action + 'Button'"
              class="HomeList__Button"
              (click)="handleButtonClick(button.action)"
              [disabled]="buttonStates[button.id].disabled"
              [innerHTML]="button.text"
            ></ion-button>
            @if (buttonStates[button.id].disabled) {
              <small
                class="HomeList__ButtonWarning"
                [innerHTML]="buttonStates[button.id].text"
              ></small>
            }
          </div>
        }
      </span>
    }

    @if (properties$ | async; as properties) {
      <ion-grid class="HomeList__Grid">
        @for (category of ['potential', 'active', 'sold']; track category) {
          <ion-row class="HomeList__Row">
            <ion-col>
              <h3 class="HomeList__Title">
                <span [innerHTML]="category"></span>
                <span class="HomeList__Hint"
                  >&nbsp;({{ cats[category].hint }})</span
                >
              </h3>
            </ion-col>
          </ion-row>
          <ion-row class="HomeList__Row">
            @let propertyList =
              properties[category].length ? properties[category] : [null];
            <ion-col>
              @for (property of propertyList; track property) {
                <app-home-list-card
                  [property]="property"
                  [category]="category"
                  class="HomeList__Card"
                ></app-home-list-card>
              }
            </ion-col>
          </ion-row>
        }
      </ion-grid>
    }
  }
</ion-content>
